import { useState } from 'react';
import Button from './Buttons/Button';
import { SingleDateInput } from './Form/Inputs/DateInput';
import Spinner from './Spinner';

export default function TestComponent() {
  const [state, setState] = useState<string | undefined>();
  const [state2, setState2] = useState<Date | undefined>(new Date('2000-1-11'));

  return (
    <div className="flex gap-5 mx-auto items-start">
      <SingleDateInput
        value={state2}
        onChange={setState2}
        onChangeStringDate={console.log}
      />
      {/* <ReactDatePicker
                showYearDropdown
                placeholderText="Select Date"
                className="w-full h-12 bg-transparent px-4 rounded-xl border border-gray-100  text-sm focus:outline-none focus:ring-1 focus:ring-gray-light placeholder-gray-lighter"

                onChange={(_) => {
                  console.log(_);
                  setState(_);
                }}

                value={
                  field.value
                    ? new Date(state).toLocaleDateString('en-US')
                    : ''
                }
              /> */}
    </div>
  );
}
